import React from 'react';

import * as Misc from './../../misc';

export default ({type}) => {
  if (!document.kvConfig.kioskMode) {
    return null;
  }

  switch (type) {
    case 'reviewSubmit':
    case 'sqftCalc-not-used-yet':
    case 'customerPopup':
    case 'lockedStone':
      return (<video id={type} className="video-guide" preload="auto">
        <source type="video/webm" src={Misc.getIntroVideo(type)}/>
      </video>);
    case 'sqftCalc': //block error until sqftcalc video exists
      return null;
  }

  console.error('Unknown intro video type: ' + type);
  return null;
};



// WEBPACK FOOTER //
// ./src/components/common/introVideo.js